export const logger=new Proxy({},{get:()=>()=>{}})